//#region src/errors/codes.ts
/**
* Every failure this library can produce, as a closed set.
*
* Codes are part of the public API: consumers branch on them, so they are
* stable across minor versions. The human-readable message is not.
*/
const MUSE_ERROR_CODES = [
	"TRANSPORT_UNAVAILABLE",
	"DEVICE_NOT_FOUND",
	"CONNECTION_LOST",
	"HANDSHAKE_FAILED",
	"PRESET_REJECTED",
	"MALFORMED_PACKET",
	"BUFFER_OVERFLOW",
	"UNSUPPORTED_DEVICE",
	"MTU_TOO_SMALL"
];
/**
* Whether retrying the same operation could plausibly succeed.
*
* This drives auto-reconnect: recoverable failures back off and retry,
* unrecoverable ones surface to the caller immediately. Deciding this once,
* here, keeps retry policy out of every call site.
*/
const RECOVERABLE = /* @__PURE__ */ new Set([
	"CONNECTION_LOST",
	"DEVICE_NOT_FOUND",
	"HANDSHAKE_FAILED",
	"MALFORMED_PACKET"
]);
function isRecoverableCode(code) {
	return RECOVERABLE.has(code);
}
//#endregion
//#region src/errors/muse-error.ts
/**
* The single error type this library throws.
*
* Consumers branch on {@link MuseError.code}, never on the message. Anything
* thrown from inside a codec, transport or stream is wrapped in one of these,
* so a `catch` block never has to guess what it caught.
*/
var MuseError = class MuseError extends Error {
	name = "MuseError";
	code;
	recoverable;
	details;
	constructor(code, message, options = {}) {
		super(message, options.cause === void 0 ? void 0 : { cause: options.cause });
		this.code = code;
		this.recoverable = options.recoverable ?? isRecoverableCode(code);
		this.details = options.details;
	}
	/** Type guard usable across realms and bundle boundaries. */
	static is(value) {
		return value instanceof MuseError;
	}
	/**
	* Wraps an unknown thrown value without losing it.
	* A `MuseError` passes through unchanged so the original code survives.
	*/
	static wrap(value, code, message, options = {}) {
		if (MuseError.is(value)) return value;
		return new MuseError(code, message, {
			...options,
			cause: value
		});
	}
};
//#endregion
export { MUSE_ERROR_CODES as n, isRecoverableCode as r, MuseError as t };

//# sourceMappingURL=muse-error-BO65y6cz.js.map